import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { useProjectPDFExport } from "entities/projects/model/useProjectPDFExport"

import { ProjectPDFOverlayFormData } from "../ProjectPDFOverlay"
import { ProjectPDFOverlayConnectorProps } from "../ProjectPDFOverlayConnector"

export interface ProjectPDFOverlayModel {
  onSubmit: (formData: ProjectPDFOverlayFormData) => void
  onCancel: () => void
}

export function useProjectPDFOverlayModel({
  payload: { projectID, isShareID }
}: ProjectPDFOverlayConnectorProps): ProjectPDFOverlayModel {
  const { closeOverlay } = useCurrentOverlay()
  const { exportProject } = useProjectPDFExport(projectID, isShareID)

  const handleSubmit = useEvent((formData: ProjectPDFOverlayFormData) => {
    exportProject(formData)
    closeOverlay()
  })

  return {
    onSubmit: handleSubmit,
    onCancel: closeOverlay
  }
}
